import styled from 'styled-components';

const TabHeader = styled.div`
  display: flex;
  flex: 1;
`;

export default TabHeader